import { render, staticRenderFns } from "./JiebanHeyueTable.vue?vue&type=template&id=0ff36172&"
import script from "./JiebanHeyueTable.vue?vue&type=script&lang=js&"
export * from "./JiebanHeyueTable.vue?vue&type=script&lang=js&"
import style0 from "./JiebanHeyueTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports